import { ShouldRender } from '../../shared/basic/ShouldRender';

interface NumberSectionProps {
  data: { value: string; label: string }[];
}

const NumberSection: React.FC<NumberSectionProps> = ({ data }) => {
  return (
    <>
      <div className='flex gap-x-2 px-2 lg:px-24 xl:py-8'>
        {data.map((item, index) => (
          <div
            key={`${item?.value}-${index}`}
            className='flex w-full items-center gap-2 md:gap-4 group'
          >
            <div className='flex justify-center flex-grow w-full h-full'>
              <div className='flex flex-col gap-y-3 xl:gap-y-9'>
                <span className='text-lg md:text-2xl  lg:text-4xl xl:text-[64px] font-medium text-primary text-center'>
                  {item.value}
                </span>
                <span className='text-gray-100  h-full text-xs md:text-sm xl:text-[20px] text-center'>
                  {item.label}
                </span>
              </div>
            </div>
            <ShouldRender check={index + 1 !== data.length}>
              <div className='border-l hidden md:flex border-gray-300 h-10 xl:h-[65px]' />
            </ShouldRender>
          </div>
        ))}
      </div>
    </>
  );
};

export default NumberSection;
